// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3hxzF","header":"ClearentDisclaimer_header__2R_ag","inner":"ClearentDisclaimer_inner__tjSUa"};